app.controller('designController', function (
    $rootScope,
    $scope,
    $state,
    $document,
    objectService,
    questionService,
    designLineService,
    questionLinjeService,
    imageService,
    sidebarSwiper,
    $uibModal
) {
    //Images aren't preloaded or all questions aren't loaded, force loading screen
    if(!imageService.isPreloadDone() || !objectService.getQuestionGroups().length) {
        $state.go('preloader');
        return;
    }

    $scope.toggles.map = false;

    $document.ready(function(){
        $scope.sidebarSwipe = new sidebarSwiper();
    });

    $scope.meta                  = questionService.meta
    $scope.metaLinje              = questionLinjeService.meta
    $scope.control               = questionService.control
    $scope.updateAnswer          = objectService.updateQuestionAnswer.bind(objectService)
    $scope.updateLinje           = objectService.updateQuestionAnswer1.bind(objectService)
    $scope.updateLinjeQuestionAnswer = objectService.updateQuestionLinje.bind(objectService)
    $scope.getPrice              = objectService.calcPrice
    $scope.hasEarlyChoices       = objectService.hasEarlyChoices
    $scope.isAlternativeDisabled = objectService.isAlternativeDisabled
    $scope.isQuestionDisabled    = objectService.isQuestionDisabled
    $scope.isGroupDisabled       = objectService.isGroupDisabled
    $scope.isTillvalslinje       = objectService.isTillvalslinje
    $scope.sidebarTillvalslinje  = 'nosidebar'
    $scope.sidebar               = 'nosidebar'

    if($scope.isTillvalslinje() === 1){
        $scope.sidebarTillvalslinje = 'sidebar'
    } else{
        $scope.sidebar = 'sidebar'
    }

    $rootScope.$on('questionChangedEvent', function () {
        var container = document.getElementById('alternatives-container');
        if(container) container.scrollTop = 0;
    });

    $scope.openTip = function(size) {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'partials/tips_modal.html',
            controller: ['$scope','question',function($scope,question){
                $scope.question = question;
            }],
            resolve: {
                question: function() {
                    return $scope.meta.question;
                }
            }
        });
    };


    if(objectService.isInEarlyChoices()) {
        questionService.initChoices()
    } else {
        if(!designLineService.designLines.length) {
            designLineService.fetchDesignLines()
                .then(function(){
                    questionService.initChoices()
                })
        } else {
            questionService.initChoices()
        }

    }

});
